<script setup>

const dairamon = useDairamon();
const { data: page} = await dairamon.pages.get(91);
const htmlContent = ref(page.value.values[0].value);
</script>

<template>
  <div>
    <h1> {{ page.title }}</h1>
    <div v-html="htmlContent"></div>
  </div>
</template>


